import React, { FC, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useParams, useHistory } from 'react-router-dom'
import ROUTES from '../utils/routes'
import { PageLayout } from '../System'
import { SkeletonLoader } from '../SkeletonLoader'
import { StorySetModal } from '../Modals'
import { SearchStorySets_searchStorySets_docs } from '../../graphql/StorySet/__generated__/SearchStorySets'
import { StyledStoriesView, useStorySets, StorySetItem } from '.'

const StoriesView: FC = () => {
  const [selectedStorySet, setSelectedStorySet] = useState<SearchStorySets_searchStorySets_docs>()
  const { _id }: any = useParams()
  const {
    loading,
    storySets,
    totalCount,
    page,
    actions: { setPage, loadStorySets }
  } = useStorySets()
  const history = useHistory()

  useEffect(() => {
    loadStorySets()
  }, [page])

  return (
    <PageLayout maxWidth={980} pageTitle="Stories">
      <StyledStoriesView>
        <h1>Stories</h1>
        <InfiniteScroll
          scrollThreshold={0.7}
          dataLength={storySets.length}
          next={() => setPage(page + 1)}
          hasMore={storySets.length < totalCount}
          loader={null}
        >
          <div className="stories-list">
            {loading && storySets.length === 0 && <SkeletonLoader type="story-list-item" />}
            {!loading &&
              storySets.map((storySet) => (
                <StorySetItem
                  onClick={() => setSelectedStorySet(storySet)}
                  key={storySet._id}
                  storySet={storySet}
                />
              ))}
          </div>
        </InfiniteScroll>
      </StyledStoriesView>
      <StorySetModal
        _id={_id}
        selectedStorySet={selectedStorySet}
        isOpen={!!_id}
        onClose={() => history.push(ROUTES.stories.list)}
      />
    </PageLayout>
  )
}

export default StoriesView
